import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled, { css } from 'styled-components';
import { marginAttributes, propsBlocker, getComponentOverride, widthAttributes } from '../../system';
import { reset, typography, pixelToRem } from '../../system/mixins';

var getRootStyle = function getRootStyle(_ref) {
  var small = _ref.small;
  var result = {};

  if (small) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            font-size: ", ";\n        "])), result, typography('paragraphSmall'), pixelToRem(14));
  } else {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            ", ";\n            font-size: ", ";\n        "])), result, typography('paragraphMedium'), pixelToRem(16));
  }

  return result;
};

export var ListRoot = styled.div.withConfig(propsBlocker)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n"])), reset, typography('paragraphMedium'), getRootStyle, getComponentOverride('List'), marginAttributes, widthAttributes);